import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/page.tsx");
